import api from '@/common/api';
import { makeResponse } from '@/common/api/utils';


export const makeFilterQueryParams = (filters) => {
  if (!filters) {
    return {};
  }
  const filterQueryParams = {
    genders: Object.keys(filters.gender).filter((el) => (filters.gender[el])).join(),
    age_min: filters.age.min || '',
    age_max: filters.age.max || '',
    provinces: filters.provinces.join(),
  };
  if (filters.researchItemFilters) {
    // This isn't the best solution - could be improved later;
    filterQueryParams.research_item_filters = JSON.stringify(filters.researchItemFilters);
  }
  return filterQueryParams;
};

export const createResearch = async (organisationSlug, data) => (
  makeResponse(
    await api.post(
      `organisations/${organisationSlug}/researches/`,
      data,
    ),
  )
);

export const fetchCommercialCategories = async () => (
  makeResponse(await api.get('commercial-categories/'))
);

export const fetchOrganisationMembers = async (organisationSlug) => (
  makeResponse(await api.get(
    'org/organisation-members/',
    { organisation_slug: organisationSlug },
  ))
);

export const fetchOrganisationStatistics = async (organisationSlug, queryParams) => (
  makeResponse(await api.get(
    `organisations/${organisationSlug}/statistics/`,
    queryParams || {},
  ))
);

// TODO: should be org/researches/register-custom/
export const registerCustomResearch = async (data) => makeResponse(await api.post('rev/researches/register-custom/', data));


export const fetchResearches = async (organisationSlug) => (
  makeResponse(await api.get(
    'org/researches/',
    { organisation_slug: organisationSlug },
  ))
);

export const fetchResearchItemsForItem = async (organisationSlug, itemId, queryParams) => (
  makeResponse(await api.get(
    'org/research-items/averages/',
    {
      ...queryParams,
      organisation_slug: organisationSlug,
      item_id: itemId,
    },
  ))
);

export const fetchResearchReviewSessions = async (researchUUID, queryParams) => (
  makeResponse(await api.get(
    'org/research-review-sessions/',
    {
      research_uuid: researchUUID,
      ...queryParams,
    },
  ))
);

export const fetchResearchItems = async (researchUUID) => (
  makeResponse(await api.get(
    `org/research-items/?research_uuid=${researchUUID}`,
  ))
);

export const extendOrganisationLicence = async (organisationSlug) => (
  makeResponse(await api.post(`organisations/${organisationSlug}/licence/`))
);


export const fetchResearchStatistics = async (researchUUID, queryParams) => (
  makeResponse(await api.get(
    `org/researches/${researchUUID}/statistics/`,
    queryParams,
  ))
);

export const createResearchExport = async (researchUUID, fileType) => (
  makeResponse(
    await api.post(
      'org/research-exports/',
      { file_type: fileType, research_uuid: researchUUID },
    ),
  )
);

export const fetchResearchType = async (researchTypeSlug, organisationSlug) => (
  makeResponse(
    await api.get(
      `research-types/${researchTypeSlug}/?organisation_slug=${organisationSlug}`,
    ),
  )
);

export const updateOrganisationMember = async (membershipId, payload) => (
  makeResponse(
    await api.patch(
      `org/organisation-members/${membershipId}/`,
      payload,
    ),
  )
);

export const fetchOrganisation = async (organisationSlug) => (
  makeResponse(await api.get(`organisations/${organisationSlug}/`))
);

export const fetchResearchTypes = async () => (
  makeResponse(
    await api.get(
      'research-types/',
    ),
  )
);

export const submitResearch = async (organisationSlug, researchUUID, data) => (
  makeResponse(await api.post(
    `organisations/${organisationSlug}/researches/${researchUUID}/submit/`,
    data,
  ))
);

export const deleteResearchItem = async (researchItemId) => (
  makeResponse(await api.delete(
    `org/research-items/${researchItemId}/`,
  ))
);

export const createResearchItem = async (data) => (
  makeResponse(await api.post('org/research-items/', data))
);

export const updateResearchItemsOrder = async (newOrder) => (
  makeResponse(
    await api.patch('org/research-items/order/', { new_order: newOrder }),
  )
);


export const duplicateResearchItem = async (researchItemId, data) => (
  makeResponse(
    await api.post(
      `org/research-items/${researchItemId}/duplicate/`,
      data,
    ),
  )
);

export const fetchResearchItem = async (researchItemId) => (
  makeResponse(
    await api.get(
      `org/research-items/${researchItemId}/`,
    ),
  )
);

export const updateItem = async (itemId, organisationSlug, data) => (
  makeResponse(
    await api.patch(
      `org/items/${itemId}/?organisation_slug=${organisationSlug}`,
      data,
    ),
  )
);

export const createItem = async (data) => (
  makeResponse(
    await api.post(
      'org/items/',
      data,
      {},
      { 'Content-Type': 'multipart/form-data' },
    ),
  )
);

// Namespace: org;
export const updateResearchAnswer = async (answerId, cleanedValue) => (
  makeResponse(
    await api.patch(
      `org/research-answers/${answerId}/`,
      { value_cleaned: cleanedValue },
    ),
  )
);

export const fetchResearch = async (researchUUID) => (
  makeResponse(await api.get(
    `org/researches/${researchUUID}/`,
  ))
);

export const updateResearch = async (researchUUID, data) => (
  makeResponse(await api.patch(
    `org/researches/${researchUUID}/`,
    data,
  ))
);

export const fetchOrganisationLocations = async (organisationSlug) => (
  makeResponse(await api.get(
    'org/organisation-locations/',
    { organisation_slug: organisationSlug },
  ))
);

export const validateResearch = async (researchUUID) => (
  makeResponse(await api.get(
    `org/researches/${researchUUID}/validate/`,
  ))
);
